import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cta: 'Save',
    deleteBeneficiary: 'Delete the beneficiary',
    title: 'Modify the information',
  },
  fr: {
    cta: 'Enregistrer',
    deleteBeneficiary: 'Supprimer le bénéficiaire',
    title: 'Modifiez les informations',
  },
} as const);
